<template>
    <b-container>
        <b-row v-if="phone !== null">
            {{phone}}
        </b-row>
        <b-row v-if="addr1 !== null">
            {{addr1}}
        </b-row>
        <b-row v-if="addr2 !== null">
            {{addr2}}
        </b-row>
        <b-row v-if="city !== null">
            {{city}}
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    components: {
        
    },
    props: {
        addr1: {
            type: String,
            default: null
        },
        addr2: {
            type: String,
            default: null
        },
        city: {
            type: String,
            default: null
        },
        phone: {
            type: String,
            default: null
        }
    },
    data() {
        return {

        }
    },
    computed: {

    }
}
</script>